import styled from '@emotion/styled';
import { DateTime, formatToWeekDay } from 'infras/datetime';
import {
  fontSize,
  fontWeight,
  mediaMax,
  spacing,
} from 'presentations/views/styles';
import {
  gray01,
  gray02,
  gray06,
  primary,
  white,
  whiteFix,
} from 'presentations/views/styles/color';
import { memo, useContext } from 'react';
import Skeleton from 'presentations/views/components/atoms/Skeleton';
import { CalendarContext } from 'presentations/views/components/atoms/Calendar/reducer/CalendarContext';

interface Props {
  date: DateTime;
  isLoading?: boolean;
  isHoliday?: boolean;
}

const Component = memo((props: Props) => {
  const { state } = useContext(CalendarContext);

  return (
    <HeaderCell>
      {props.isLoading ? (
        <Skeleton width={32} variant="text" />
      ) : (
        <>
          <Day
            color={state.primaryColor}
            isToday={
              state.now.toFormat('yyyyMMdd') === props.date.toFormat('yyyyMMdd')
            }
          >
            {props.date.day}
          </Day>
          <WeekDay>{formatToWeekDay(props.date)}</WeekDay>
        </>
      )}
    </HeaderCell>
  );
});

const HeaderCell = styled.div<{ isHoliday?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${spacing(8)} 0;
  /* background-color: ${(props) => props.isHoliday && gray06}; */
  color: ${(props) => (props.isHoliday ? gray02 : gray01)};
  ${mediaMax.smartphone} {
    flex-direction: column-reverse;
  }
`;
const Day = styled.div<{ isToday: boolean; color?: string }>`
  font-size: ${fontSize(16)};
  font-weight: ${fontWeight('bold')};
  line-height: 1;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.isToday && (props.color || primary)};
  color: ${(props) => props.isToday && whiteFix};
`;
const WeekDay = styled.div`
  font-size: ${fontSize(13)};
  margin-left: ${spacing(8)};
  ${mediaMax.smartphone} {
    margin-left: 0;
    font-size: ${fontSize(10)};
    margin-bottom: ${spacing(4)};
  }
  line-height: 1;
`;
export default Component;
